import DoneIcon from '@mui/icons-material/Done';
import { Box, Stack, Typography, styled } from '@mui/material';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ButtonsPrimary, ButtonsTertiary } from '../../../components/ComponentApp/buttoms';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import { TitleProfile } from '../../../components/Layout/InternalLayout/TitleHeader';
import { TitleSectionName } from '../../../components/Layout/InternalLayout/TitleSectionName';
import Spinner from '../../../components/Spinner';
import ModalErrorFetch from '../../../components/UI/ModalErrorFetch';
import useModal from '../../../hooks/custom/useModal';
import useGetConstants from '../../../hooks/useGetConstants';
import { resetUpdateUserAttributesSubmit } from '../../../redux/auth';
import {
  setCivilStatus,
  setGenders,
  setMoneyIncomes,
  setMoneyOrigin,
  setMonths,
  setNationalities,
  setProfessions,
  setRegions,
  setcountryPhones,
} from '../../../redux/constants';
import { onRefresh } from '../../../utils/refreshPage';

const ProfileContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
  margin: `${theme.spacing(10)} ${theme.spacing(2.5)} ${theme.spacing(5)} ${theme.spacing(2.5)}`,
  [theme.breakpoints.up('md')]: {
    margin: `${theme.spacing(12.5)} ${theme.spacing(2.5)} ${theme.spacing(
      5,
    )} ${theme.spacing(2.5)}`,
  },
}));
const ContentWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  width: '70%',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(4),
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    width: '100%',
  },
}));
const ProfileIconWrapper = styled(Box)({
  width: '100px',
  height: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
const TitleRiskProfile = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.titleText.fontSize,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
  lineHeight: '105%',
  textDecoration: 'none',
  textTransform: 'none',
}));
const TitleRiskProfileSpan = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.smallText.fontWeight,
  fontSize: theme.typography.mediumText.fontSize,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.smallText.fontSize,
  },
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
}));
export const IconsRiskProfile = styled('img')({
  objectFit: 'cover',
  width: '100px',
  height: '100px',
});
const ProfileTextWrapper = styled(Box)(({ theme }) => ({
  width: '80%',
  marginTop: '-10px',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
const InfoCard = styled(Stack)(({ theme }) => ({
  width: '70%',
  boxSizing: 'border-box',
  flexDirection: 'column',
  padding: 'clamp(1rem, -1.8571rem + 12.1905vw, 3rem)',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px rgba(0,0,0,0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '1rem',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}));
const TextGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(0.75),
}));
const BtnsRiskProfile = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '32px 0px 0px 0px',
  maxWidth: { md: '60%' },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

const Profile = () => {
  const { isShowing, toggle } = useModal();
  const {
    loadingUpdateUserAttributes,
    successUpdateUserAttributes,
    errorUpdateUserAttributes,
    user,
  } = useSelector(state => state.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: constants, error: errorConstants, loading: loadingConstants } = useGetConstants();

  useEffect(() => {
    if (successUpdateUserAttributes && !loadingUpdateUserAttributes) {
      dispatch(resetUpdateUserAttributesSubmit());
      navigate('/myprofilerisk');
    }
  }, [loadingUpdateUserAttributes, successUpdateUserAttributes]);

  useEffect(() => {
    if (constants && !loadingConstants) {
      dispatch(setcountryPhones(constants.getCountryPhones));
      dispatch(setGenders(constants.getGenders));
      dispatch(setMonths(constants.getMonths));
      dispatch(setCivilStatus(constants.getCivilStatus));
      dispatch(setProfessions(constants.getProfessions));
      dispatch(setMoneyIncomes(constants.getMoneyIncomes));
      dispatch(setMoneyOrigin(constants.getMoneyOrigin));
      dispatch(setNationalities(constants.getNationalities));
      dispatch(setRegions(constants.getRegions));
    }
  }, [constants, loadingConstants]);

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'onboarding profile',
        path: '/profile',
        link: {
          url: '/profile',
          title: 'onboarding',
        },
      },
    });
  }, []);

  if (loadingUpdateUserAttributes) {
    return <Spinner />;
  }
  if (errorUpdateUserAttributes) {
    return (
      <ModalErrorFetch
        message='Oh! parece que esto no funcionó bien...'
        error={errorUpdateUserAttributes}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  return (
    <>
      <HeaderLayout showLogoOnly />
      <ProfileContainer>
        <ContentWrapper>
          <ProfileIconWrapper>
            <IconsRiskProfile src={'/assets/images/perfil-noDefined.svg'} />
          </ProfileIconWrapper>
          <ProfileTextWrapper>
            <TitleSectionName
              user={user}
              description={'tu perfil de inversionista no está definido'}
            />
          </ProfileTextWrapper>
        </ContentWrapper>
        <InfoCard>
          <TextGroup>
            <Stack>
              <TitleProfile text={'Mi Perfil de inversiones'} />
            </Stack>
            <Stack marginTop={'20px'}>
              <TitleRiskProfile>
                En este proceso aprenderás a definir cual es el perfil de riesgo que se adecua a tus
                necesidades.
              </TitleRiskProfile>
            </Stack>
            <Stack marginTop={'10px'}>
              <TitleRiskProfileSpan>
                Puedes volver a realizar el cuestionario en cualquier momento dentro de Xcala.
              </TitleRiskProfileSpan>
            </Stack>
          </TextGroup>

          <BtnsRiskProfile sx={{ gap: { xs: '10px', md: '2rem' } }}>
            <ButtonsPrimary
              name='Definir mi perfil de Riesgo'
              onClick={() => navigate('/questions')}
              icon={<DoneIcon />}
            />
            <ButtonsTertiary
              name='Ya se cual es mi perfil de riesgo'
              onClick={() => navigate('/profileselect')}
            />
          </BtnsRiskProfile>
        </InfoCard>
      </ProfileContainer>
    </>
  );
};

export default Profile;
